import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      © {new Date().getFullYear()} SK Logistics. Designed by <a href='https://sanyogsoft.com' target='_blank'> Sanyog Software </a> .
    </footer>
  );
}
